import styled from 'styled-components'
import { colors } from 'styles/colors'

export const Container = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        .__react_component_tooltip {
            left: 0;
        }
        margin-right: 6px;
    }
`

export const Panel = styled.div`
    border-radius: 8px;
    background-color: ${colors.gray_F7};
    padding: 12px;

    display: flex;
    align-items: center;

    > * + * {
        margin-left: 13px;
    }

    @media (max-width: 768px) {
        padding: 8px;
        gap: 4px;
        font-size: 14px;

        > * + * {
            margin-left: 0;
        }
    }
`

export const ClickableContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    color: white;
    background-color: #0e7f61;

    border-radius: 50%;
    width: 18px;
    height: 18px;

    i {
        font-weight: 700;
        font-style: normal;
        display: block;
        font-size: 13px;
    }
`

export const SwitchText = styled.p`
    margin-right: 13px;

    @media (max-width: 768px) {
        margin-right: 0;
    }

    font-weight: 600;
`
